import { render, staticRenderFns } from "./oftenHref.vue?vue&type=template&id=a5b271dc"
import script from "./oftenHref.vue?vue&type=script&lang=js"
export * from "./oftenHref.vue?vue&type=script&lang=js"
import style0 from "./oftenHref.vue?vue&type=style&index=0&id=a5b271dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports